export enum BookingStep {
  SELECTING = 'selecting',     // Selecting location/neighborhood
  PAYMENT = 'payment',          // Payment modal open
  PROCESSING = 'processing',    // Payment submitted, polling for completion
  SUCCESS = 'success',          // Booking complete
}

